exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resource-row{\r\n    line-height: 32px;\r\n    height:32px;\r\n}\r\n\r\n.resource-header{\r\n    line-height: 35px;\r\n    height:35px;\r\n}\r\n\r\n.missing{\r\n    background: rgba(255,0,0,0.1);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/resource-column/resource-column.component.css
// module id = ../../../../../src/app/resource-column/resource-column.component.css
// module chunks = 1